module.exports = __webpack_public_path__ + "img/20181213_231258_thumb.bd92f8c9.jpg";